import { Route } from 'react-router-dom';

import { RequireBroker } from '../../common/SharedComponents';
import { RequirePendingBroker } from '../../common/SharedComponents';
import { RequireBrokerEsign } from '../../common/SharedComponents';

import { ReferralSummaryV2 } from '../../brokerPortalV2/referrals/ReferralSummaryV2/ReferralSummaryV2';
import { BrokerSettingsV2 } from '../../brokerPortalV2/broker/settings/BrokerSettingsV2';
import { BrokerScss } from '../components/BrokerScss';
import AccountSetup from '../../brokerPortalV2/broker/accountSetup/AccountSetup';
import { BrokerSignAgreementV2 } from '../../brokerPortalV2/broker/signAgreement/BrokerSignAgreementV2';

export default function BrokerRoutesV2() {
    return (
        <Route element={<BrokerScss />}>
            <Route
                path='/referrals'
                element={
                    <RequireBroker>
                        <ReferralSummaryV2 />
                    </RequireBroker>
                }
            />

            <Route
                path='/settings'
                element={
                    <RequireBroker>
                        <BrokerSettingsV2 />
                    </RequireBroker>
                }
            />

            <Route
                path='/brokeraccount'
                element={
                    <RequirePendingBroker>
                        <AccountSetup />
                    </RequirePendingBroker>
                }
            />

            <Route
                path='/broker/signagreement'
                element={
                    <RequireBrokerEsign>
                        <BrokerSignAgreementV2 />
                    </RequireBrokerEsign>
                }
            />
        </Route>
    );
}
